import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Gender = ({ gender, size }) => (
  gender && gender.length > 0 && <FontAwesomeIcon icon={gender === "M" ? "male" : ( gender === "F" ? "female" : "genderless")} size={size}/>
);

export default Gender
